import { Filters } from '../types'

export const DEFAULT_FILTERS: Filters = {
  radius: 25,
  postedWithinDays: 0,
  onlyAutoApplyJobs: false,
  jobLocationType: null,
  jobType: null,
}
